import { createSelector } from '@reduxjs/toolkit';

import getCarsParameters from '@/features/cars/helpers/getCarsParameters';
import { configSelector } from '@/features/config/selectors';
import type { RootState } from '@/features/store';

import { carsApi } from '../reducer';

import carsSelector from './cars';
import carsParametersSelector from './parameters';

/**
 * Получить результат запроса на получение автомобилей
 */
const carsDataSelector = createSelector(
  [
    carsSelector,
    carsParametersSelector,
    configSelector,
    (_: RootState, page?: number) => page ?? 0,
  ],
  (cars, parameters, config, page) => {
    const updatedParameters = getCarsParameters(parameters, config, page);
    return carsApi.endpoints.getCars.select(updatedParameters)({
      cars,
    });
  },
);

export default carsDataSelector;
